import { IMAGES } from '../../constant/theme';

export const gridDataBlog = [
    { 
        image: IMAGES.smallpic2, name:'Alexander', subject:'M.COM., P.H.D.',
        content:[
            { 
                title:'gender', 
                subtitle:'Male'
            },
            {
                title:'Phone No',
                subtitle:'+01 123 456 7890'
            },
            {
                title:'Email:',
                subtitle:'info@example.com'
            },
            {
                title:'Address',
                subtitle:'#8901 Marmora Road'
            },
        ]
    }, 
    { 
        image:IMAGES.smallpic3, name:'Elizabeth', subject:'B.COM., M.COM.',
        content:[
            { 
                title:'Gender', 
                subtitle:'Female'
            },
            {
                title:'Phone No',
                subtitle:'+01 123 456 7890'
            },
            {
                title:'Email:',
                subtitle:'info@example.com'
            },
            {
                title:'Address',
                subtitle:'#8901 Marmora Road'
            },
            
        ]
    }, 
    { 
        image:IMAGES.smallpic4, name:'Amelia', subject:'M.COM., P.H.D.',
        content:[
            { 
                title:'Gender', 
                subtitle:'Female'
            },
            {
                title:'Phone No',
                subtitle:'+01 123 456 7890'
            },
            {
                title:'Email:',
                subtitle:'info@example.com'
            },
            {
                title:'Address',
                subtitle:'#8901 Marmora Road'
            },
            
        ]
    }, 
    { 
        image:IMAGES.smallpic5, name:'Charlotte', subject:'B.COM., M.COM.',
        content:[
            { 
                title:'Gender', 
                subtitle:'Female'
            },
            {
                title:'Phone No',
                subtitle:'+01 123 456 7890'
            },
            {
                title:'Email:',
                subtitle:'info@example.com'
            },
            {
                title:'Address',
                subtitle:'#8901 Marmora Road'
            },
            
        ]
    }, 
    { 
        image:IMAGES.smallpic6, name:'Isabella', subject:'B.A, B.C.A',
        content:[
            { 
                title:'Gender', 
                subtitle:'Female'
            },
            {
                title:'Phone No',
                subtitle:'+01 123 456 7890'
            },
            {
                title:'Email:',
                subtitle:'info@example.com'
            },
            {
                title:'Address',
                subtitle:'#8901 Marmora Road'
            },
            
        ]
    }, 
    { 
        image: IMAGES.smallpic7, name:'Sebastian', subject:'M.COM., P.H.D.',
        content:[
            { 
                title:'gender', 
                subtitle:'Male'
            },
            {
                title:'Phone No',
                subtitle:'+01 123 456 7890'
            },
            {
                title:'Email:',
                subtitle:'info@example.com'
            },
            {
                title:'Address',
                subtitle:'#8901 Marmora Road'
            },
        ]
    }, 
    { 
        image:IMAGES.smallpic8, name:'Olivia', subject:'B.COM., M.COM.',
        content:[
            { 
                title:'Gender', 
                subtitle:'Female'
            },
            {
                title:'Phone No',
                subtitle:'+01 123 456 7890'
            },
            {
                title:'Email:',
                subtitle:'info@example.com'
            },
            {
                title:'Address',
                subtitle:'#8901 Marmora Road'
            },
            
        ]
    },
    { 
        image:IMAGES.smallpic9, name:'Emma', subject:'B.A, B.C.A',
        content:[
            { 
                title:'Gender', 
                subtitle:'Female'
            },
            {
                title:'Phone No',
                subtitle:'+01 123 456 7890'
            },
            {
                title:'Email:',
                subtitle:'info@example.com'
            },
            {
                title:'Address',
                subtitle:'#8901 Marmora Road'
            },
            
        ]
    },
    { 
        image:IMAGES.smallpic10, name:'Jackson', subject:'M.COM., P.H.D.',
        content:[
            { 
                title:'Gender', 
                subtitle:'Female'
            },
            {
                title:'Phone No',
                subtitle:'+01 123 456 7890'
            },
            {
                title:'Email:',
                subtitle:'info@example.com'
            },
            {
                title:'Address',
                subtitle:'#8901 Marmora Road'
            },
            
        ]
    },
];

